export default __webpack_public_path__ + "static/media/N172L-Outside.81e931b1.png";